import { useEffect, useRef } from 'react';

export function useResetScrollAfterMobileKeyboard() {
  const prevHeightRef = useRef(null);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;

    const mq = window.matchMedia('(max-width: 1023px)');

    const scrollTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    const onResize = () => {
      if (!mq.matches) {
        prevHeightRef.current = vv.height;
        return;
      }
      const h = vv.height;
      const prev = prevHeightRef.current;
      if (prev != null && h > prev + 72) {
        scrollTop();
      }
      prevHeightRef.current = h;
    };

    prevHeightRef.current = vv.height;
    vv.addEventListener('resize', onResize);
    return () => {
      vv.removeEventListener('resize', onResize);
      prevHeightRef.current = null;
    };
  }, []);
}
